export const LOADING_ENGINE = 'LOADING_ENGINE'
export const LOADING_INFO = 'LOADING_INFO'
export const SET_ENGINE_STATUS = 'SET_ENGINE_STATUS'
export const UPDATE_ENGINE_INFO = 'UPDATE_ENGINE_INFO'

export default {
  LOADING_ENGINE,
  LOADING_INFO,
  SET_ENGINE_STATUS,
  UPDATE_ENGINE_INFO,
}
